<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="fm05_hd">
<h1 class="h1" id="fm05_hd"><span aria-label=" page 4. " epub:type="pagebreak" id="page_4" role="doc-pagebreak">Tokyo Daily News</span></h1>
<p class="sutxt">May 3, 2003</p>
<p class="indent">“We Hear…”</p>
<p class="indent">It’s official: Heaven Kogo, the adopted nineteen-year-old daughter of business bigwig Konishi Kogo, will marry suave playboy Teddy Yukemura, son of Yoji Yukemura, in a lavish ceremony before the year is out. The often public feuding between the Kogo and Yukemura business empires makes this marriage even more of a shocker. Who knew that little Heaven Kogo, Japan’s “good-luck girl,” had given her heart to one of Tokyo’s most eligible bachelors? But with Teddy’s money and status, passel of bright young friends, and (so they say) burgeoning business sense, maybe we should have seen it all along. One thing’s for sure—this gorgeous heiress will be well taken care of in her new home. We promise to keep you updated on the details of the wedding as they emerge…. Shhh….</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm05.vue?67b6995c